import styles from './ContentReviewNote.module.css';

type ContentReviewNoteProps = {
  reviewedAt?: string;
  reviewer?: string;
};

export default function ContentReviewNote({
  reviewedAt = 'August 20, 2026',
  reviewer = 'LifeShack content team',
}: ContentReviewNoteProps) {
  return (
    <aside
      aria-label="Content review information"
      className={styles.note}
    >
      Reviewed by {reviewer} on {reviewedAt}. Product capabilities and limits
      can change; check the current signup and pricing screens before choosing
      a plan.
    </aside>
  );
}
